"use client";

import Script from "next/script";
import React, { useEffect, useRef } from "react";

import useGoogleMap from "@/hooks/useGoogleMap";
import { Map } from "@/types";

import "./Map.css";
import countryPlaceIdMapping from "./config/countryPlaceIdMapping";
import { MapComponentProps } from "./type";

const getPlaceIdsForCountries = (countries: string[]) => {
  const placeIds = countries.map((country) => countryPlaceIdMapping[country]).filter((id) => id);
  return placeIds;
};

interface MapComponentPropsExtended extends MapComponentProps {
  entry: Map;
  selectedTabIndex: number;
  mapOptions?: google.maps.MapOptions;
  googleMapApiKey: string;
  onMapInit?: Function;
}

const MapComponent: React.FC<MapComponentPropsExtended> = ({ entry, selectedTabIndex = 0, mapOptions, googleMapApiKey, onMapInit }) => {
  const mapRef = useRef<HTMLDivElement>(null);

  let center = { lat: Math.round(entry.center.lat), lng: Math.round(entry.center.lon) };

  const { map, setScriptLoaded } = useGoogleMap(mapRef, center, entry.zoom, { ...mapOptions });

  useEffect(() => {
    if (map) {
      map.data.forEach((feature) => {
        map.data.remove(feature);
      });

      const desiredPlaceIds = getPlaceIdsForCountries(entry.tabs[selectedTabIndex].countries);

      const featureLayer = map.getFeatureLayer(google.maps.FeatureType.COUNTRY);

      const featureStyleOptions: google.maps.FeatureStyleOptions = {
        strokeColor: "#AEB8C2",
        strokeOpacity: 1.0,
        strokeWeight: 2.0,
        fillColor: "#E8DBBF",
        fillOpacity: 1.0,
      };

      //@ts-ignore
      featureLayer.style = (options: { feature: { placeId: string } }) => {
        if (desiredPlaceIds.includes(options.feature.placeId)) {
          return featureStyleOptions;
        }
      };
    }
  }, [map, selectedTabIndex]);

  useEffect(() => {
    if (map && onMapInit) {
      onMapInit(map);
    }
  }, [map]);
  return (
    <div className="grow" style={{ color: "#222222" }}>
      <div className={`min-h-[400px] h-[calc(100dvh_-_50px)] md:h-[626px] ${entry.interactive ? "" : "disable-interaction"}`} id="map" ref={mapRef}>
        <Script
          onReady={() => {
            setScriptLoaded(true);
          }}
          id="google-maps"
          strategy="lazyOnload"
          src={`https://maps.googleapis.com/maps/api/js?key=${googleMapApiKey}&libraries=places,marker&v=quarterly`}
        />
      </div>
    </div>
  );
};

export default MapComponent;
